export function startMigration() {
  return { type: '@migration/START_MIGRATION' };
}

export function retryMigration() {
  return { type: '@migration/RETRY_MIGRATION' };
}

export function startPolling() {
  return { type: '@migration/START_POLLING' };
}

export function stopPolling() {
  return { type: '@migration/STOP_POLLING' };
}

export function updateStatus(data) {
  return { type: '@migration/UPDATE_STATUS', payload: { data } };
}

export function resetMigration() {
  return { type: '@migration/RESET' };
}

export function dismissBanner() {
  return { type: '@migration/DISMISS_BANNER' };
}
